import { defineFcm } from '../shared/factory';

export const FCM_PETITION_ACTIVITY_NPO_UNVERIFIED_BANNER = defineFcm('petition_activity_npo_unverified_banner')
	.asBoolean()
	.withDefault(false)
	.toConfig({
		owner: 'squad-dolphin',
		scope: 'corgi-front-end',
		context: 'Petition Activity',
		description:
			'When enabled, shows an info banner on the Petition Activity page when a petition belongs to an unverified nonprofit organization, explaining that signer email addresses cannot be exported until the account is verified.',
		import: false,
	});
